import { IconName } from '@entities/Product/module/types/productSchema';

export enum ActionTypeProduct {
  Tyres = 1,
  Disks,
  Akb,
  Oils,
  TireFitting,
}

export interface ActionItemType {
  id: number;
  sort: number;
  name: string;
  href: string;
  announcePicture: string;
  actionRn: number;
}

export interface ActionByProductTypes {
  name: string;
  shortName: string;
  code: string;
}

export enum StickerType {
  Actions,
  Warranties,
}

export interface badgesProductTypes {
  code: string;
  url?: string;
  text?: string;
  type: StickerType;
}

export interface ReturnFetchActionsByProduct {
  actions: ActionByProductTypes[];
  stickers: badgesProductTypes[];
}

export interface ActionByBrand {
  id: number;
  erId: string;
  name: string;
  shortName: string;
  code: string;
  rn: number | null;
}

export interface ActionSchema {
  listByTypeProduct: ActionItemType[];
  actionsByProduct: ActionByProductTypes[];
  badgesByProduct: badgesProductTypes[];
  isLoading: boolean;
  error?: string;
  listActionByBrand: ActionByBrand[];
}
